












import { Vue, Component } from 'vue-property-decorator'
import SettingBase from './components/setting-base.vue'
import SettingMessage from './components/setting-message.vue'

@Component({
  name: 'Settings',
  components: {
    SettingBase,
    SettingMessage
  }
})
export default class extends Vue {}
